/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ContentChildren, Directive, Input, QueryList } from '@angular/core';
import { MenuItemDirective } from './menu.item.directive';

@Directive({
    selector: '[appMenuGroup]',
})

export class MenuGroupDirective {
    /**
     * Get the child menu items
     */
    @ContentChildren(MenuItemDirective, { descendants: true })
    public content: QueryList<MenuItemDirective>;

    /**
     * Enable/Disable
     */
    @Input() public disabled: boolean;

    /**
     * Pass the ID through to the html of the menu
     */
    @Input() public id: string;

    /**
     * Pass the class through to the html of the menu
     */
    @Input() public class: string;

    /**
     * Router navigation location
     */
    @Input() public loc: string;

    /**
     * Toggle whether this group has any menu items or not.
     */
    @Input() public isOnlyHeader = false;

    /**
     * Group heading/title
     */
    @Input() public heading: string;

    /**
     * Menu item image
     */
    @Input() public iconLocation: string;

    /**
     * Specify whether we are linking away
     */
    @Input() public link: boolean;

    /**
     * Determines whether opened in a new tab or not
     */
    @Input() public targetNew: boolean;

    /**
     * Specify modal to launch if stated
     */
    @Input() public modal: string;

    /**
     * Child group flag.
     */
    @Input() public isChild: boolean;

    /**
     * Show or hide the subscription icon.
     */
    @Input() public subscriptionRequired: boolean = false;

    /**
     * Store children of menu item.
     */
    @Input() public children: MenuItemDirective[];

    /**
     * Specify function to be called
     */
    @Input() public callBack: (...args: any[]) => void;

    /**
     * Hide menu item.
     */
    @Input() public hidden: boolean = false;

    /**
     * Add coming soon class to menu item.
     */
    @Input() public comingSoon: boolean = false;

    /**
     * Add external link class to menu item.
     */
    @Input() public externalLink: boolean = false;

    /**
     * Hide the group Items
     */
    public groupHidden = true;

    /**
     * Items variable getter that returns each menu item
     * @returns {MenuItemDirective[]}
     */
    get items(): MenuItemDirective[] {
        return this.content.toArray();
    }
}
